import { defaultCalculsFilters, FINISHED, IN_PROGRESS } from "../../constants";
import { CloseCircle } from "../../../../assets/icons/CloseCircle";

export const CalculsFiltersBanner = ({ filters, updateFilters, folderId }) => {
  const handleResetFilters = () => {
    updateFilters(defaultCalculsFilters, folderId);
  };

  return JSON.stringify(filters) !== JSON.stringify(defaultCalculsFilters) ? (
    <div className="filter-badges-container d-flex align-items-center mx-1">
      {/* ---- STATUS ---- */}
      {filters.statuses.map((status) => (
        <FilterBadge
          key={status}
          text={
            status === IN_PROGRESS
              ? "En cours"
              : status === FINISHED
                ? "Finalisé"
                : status
          }
          onClick={() =>
            updateFilters(
              {
                ...filters,
                statuses: filters.statuses.filter((s) => s !== status),
              },
              folderId,
            )
          }
        />
      ))}
      {filters.productFamilies.map((pf) => (
        <FilterBadge
          key={`filter-badge-${pf.id}`}
          text={pf.text}
          onClick={() =>
            updateFilters(
              {
                ...filters,
                productFamilies: filters.productFamilies.filter(
                  (p) => p.id !== pf.id,
                ),
              },
              folderId,
            )
          }
        />
      ))}
      {!folderId &&
        filters.folders.map((folder) => (
          <FilterBadge
            key={`filter-badge-${folder.id}`}
            text={folder.text}
            onClick={() =>
              updateFilters(
                {
                  ...filters,
                  folders: filters.folders.filter((f) => f.id !== folder.id),
                },
                folderId,
              )
            }
          />
        ))}
      {filters.updatedAt &&
        filters.updatedAt.$gte &&
        filters.updatedAt.$lte && (
          <FilterBadge
            key="filter-badge-updatedAt"
            text={`Modifié entre le ${new Date(filters.updatedAt.$gte).toLocaleDateString()} et le ${new Date(filters.updatedAt.$lte).toLocaleDateString()}`}
            onClick={() =>
              updateFilters(
                {
                  ...filters,
                  updatedAt: { $gte: undefined, $lte: undefined },
                },
                folderId,
              )
            }
          />
        )}
      {filters.result &&
        filters.result.$gte !== undefined &&
        filters.result.$lte !== undefined && (
          <FilterBadge
            key="filter-badge-result"
            text={`${filters.result.$gte} à ${filters.result.$lte} kg CO2`}
            onClick={() =>
              updateFilters(
                {
                  ...filters,
                  result: { $gte: undefined, $lte: undefined },
                },
                folderId,
              )
            }
          />
        )}
      <button
        className="no-style text-interaction reset-filters-button"
        onClick={handleResetFilters}
      >
        Réinitialiser les filtres
      </button>
    </div>
  ) : null;
};

const FilterBadge = ({ onClick, text }) => {
  return (
    <div
      className="no-style filter-badge text-interaction bg-interaction-clear d-flex align-items-center cursor-pointer"
      onClick={onClick}
    >
      {text}
      <div className="d-flex align-items-center" style={{ marginLeft: 4 }}>
        <CloseCircle size={16} className="text-interaction" opacity={0.7} />
      </div>
    </div>
  );
};
